type Listener = () => void;

const listeners = new Set<Listener>();

// 「背後を暗くする幕を出したい」と言っているパネルの数。
// 0 より大きい間だけ幕を表示する。アプリ全体で幕は1枚だけ（MenuOverlayHost）を使い回す。
let openCount = 0;

function emit() {
  listeners.forEach((listener) => listener());
}

/** 幕の開閉状態を購読する（useSyncExternalStore 用）。 */
export function subscribeMenuOverlay(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** 幕を出すべきパネルが1つ以上開いているか。 */
export function getMenuOverlayOpen(): boolean {
  return openCount > 0;
}

/** パネルを1つ開いたことを幕へ伝える。 */
export function pushMenuOverlay(): void {
  openCount += 1;
  emit();
}

/** パネルを1つ閉じたことを幕へ伝える。 */
export function popMenuOverlay(): void {
  openCount = Math.max(0, openCount - 1);
  emit();
}